import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
});

api.interceptors.request.use((config) => {
  let token = localStorage.getItem("userF");

  if (token) {
    // ✅ Quitar comillas si viene como '"eyJ..."'
    token = token.trim().replace(/^"+|"+$/g, "");
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;